import moment from "moment-timezone";
import momentDurationFormatSetup from "moment-duration-format";

const DateFormat = () => {
	momentDurationFormatSetup(moment);

	const abbrs = {
		"-03": "GMT-3"
	};

	// eslint-disable-next-line func-names
	moment.fn.zoneName = function () {
		const abbr = this.zoneAbbr();
		return abbrs[abbr] || abbr;
	};

	const formatMilliseconds = (ms, format = "hh:mm:ss") => {
		const floored = Math.floor(ms / 1000) * 1000;
		return moment.duration(floored).format(format, { trim: false });
	};

	const millisecondsToArray = (ms) => {
		const duration = moment.duration(ms);
		const h = duration.hours();
		const m = duration.minutes();
		const s = duration.seconds();

		return [h, m, s];
	};

	const formatISODate = (dateString, format = "MM/DD/yy hh:mm") => {
		return moment(dateString).format(format);
	};

	const getLocalTimezoneAbbr = () => {
		return moment.tz(moment.tz.guess()).format("zz");
	};

	const formatIsoUtcToLocal = (
		dateString,
		format = "MM/DD/yy hh:mm a",
		includeZoneAbbr
	) => {
		let out = moment.utc(dateString).local().format(format);
		if (includeZoneAbbr) {
			out += ` ${getLocalTimezoneAbbr()}`;
		}

		return out;
	};

	const formatIsoUtcWithTz = (
		dateString,
		tz,
		format = "MM/DD/yy hh:mm a zz"
	) => {
		return tz
			? moment.utc(dateString).tz(tz).format(format)
			: formatIsoUtcToLocal(dateString, format);
	};

	const subtractDays = (date, days) => {
		return date ? moment(date).subtract({ days }) : null;
	};

	const addDays = (date, days) => {
		return date ? moment(date).add({ days }) : null;
	};

	const toISOString = (date) => {
		return date ? moment(date).toISOString() : null;
	};

	const format = (date, pattern = "YYYY-MM-DD hh:mm:ss") => {
		return date ? moment(date).format(pattern) : null;
	};

	const toShortISODate = (date) => {
		return date ? moment(date).format("YYYY-MM-DD") : null;
	};

	const toISOStringWithTz = (
		date,
		time,
		timeZone,
		dateFormat = "MM/DD/yy",
		timeFormat = "HH:mm"
	) => {
		return moment.tz(`${date} ${time}`, `${dateFormat} ${timeFormat}`, timeZone);
	};

	return {
		format,
		formatMilliseconds,
		formatISODate,
		formatIsoUtcToLocal,
		formatIsoUtcWithTz,
		getLocalTimezoneAbbr,
		addDays,
		subtractDays,
		toISOString,
		toISOStringWithTz,
		toShortISODate,
		millisecondsToArray
	};
};

export default DateFormat();
